import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const PrivateRoute = ({ children, allowedRoles }) => {
    const token = Cookies.get('token');
    const roleName = Cookies.get('role');
    const location = useLocation();
    if (!token) {
      return <Navigate to="/login" />;
    }
    
    if (!allowedRoles.includes(roleName)) {
        return <Navigate to="/pageNotFound" />;
      }
  
    return children; 
}

export default PrivateRoute